/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { IOasHeaderParent } from '../../openapi/models/IOasHeaderParent';
import { OasHeader } from '../../openapi/models/OasHeader';
import { Node } from '../../core/models/Node';

/**
 * A command used to rename a schema header.
 * @author vvilerio
 * @extends AbstractCommand
 * @class
 */
export class RenameHeaderCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _oldHeaderName : string;

    public _newHeaderName : string;

    public constructor(parent? : any, oldHeaderName? : any, newHeaderName? : any) {
        if(((parent != null && parent instanceof <any>OasHeader) || parent === null) && ((typeof oldHeaderName === 'string') || oldHeaderName === null) && ((typeof newHeaderName === 'string') || newHeaderName === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldHeaderName===undefined) this._oldHeaderName = null;
            if(this._newHeaderName===undefined) this._newHeaderName = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldHeaderName===undefined) this._oldHeaderName = null;
            if(this._newHeaderName===undefined) this._newHeaderName = null;
            (() => {
                this._oldHeaderName = oldHeaderName;
                this._newHeaderName = newHeaderName;
                this._parentPath = Library.createNodePath(parent);
            })();
        } else if(parent === undefined && oldHeaderName === undefined && newHeaderName === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldHeaderName===undefined) this._oldHeaderName = null;
            if(this._newHeaderName===undefined) this._newHeaderName = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldHeaderName===undefined) this._oldHeaderName = null;
            if(this._newHeaderName===undefined) this._newHeaderName = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[RenameHeaderCommand] Executing.");
        this._doHeaderRename(document, this._oldHeaderName, this._newHeaderName);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[RenameHeaderCommand] Reverting.");
        this._doHeaderRename(document, this._newHeaderName, this._oldHeaderName);
    }

    /**
     * Does the work of renaming a path from one name to another.
     * @param {Document} document
     * @param {string} from
     * @param {string} to
     * @private
     * @private
     */
    /*private*/ _doHeaderRename(document : Document, from : string, to : string) {
        let parent : IOasHeaderParent = <IOasHeaderParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        if(!this.isNullOrUndefined(parent.getHeader(to))) {
            return;
        }
        let header : OasHeader = <OasHeader>parent.removeHeader(from);
        if(this.isNullOrUndefined(header)) {
            return;
        }
        header.rename(to);
        parent.addHeader(to, header);
    }
}
RenameHeaderCommand["__class"] = "io.apicurio.datamodels.cmd.commands.RenameHeaderCommand";
RenameHeaderCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




